import script from "./TheContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./TheContainer.vue?vue&type=script&setup=true&lang=js"

import "./TheContainer.vue?vue&type=style&index=0&id=23efd04e&scoped=true&lang=scss"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23efd04e"]])

export default __exports__